import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  InputAdornment,
  TextField,
  MenuItem,
  Select,
  Menu,
} from "@mui/material";
import { Notifications, CalendarToday, Search } from "@mui/icons-material";
import "chart.js/auto";
import { styled } from "@mui/joy/styles";
import CloseIcon from "@mui/icons-material/Close";
import { FormControl, InputLabel } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { TableComponent } from "../../components";
import AppHeaderBar from "../../components/AppBar/appBar";
// import { useFetch } from "../../hooks/useFetch";
import { useFetch } from "../../hooks";
import { urls } from "../../urls/urls";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Sector,
} from "recharts";

import {
  convertTimestampToDate,
  getCurrentGreeting,
  getDate,
} from "../../utils";

const SearchBox = styled(TextField)({
  // borderRadius: '30px',
  backgroundColor: "transparent",
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    border: `1px solid #E1DDDC`,
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D2CFCF",
  },
  width: "100%",
});

const DashboardContent = ({ onBackScreenName }) => {
  // const navigate = useNavigation()
  const loginToken = useSelector((state) => state.user.apptoken);  
  const {
    data: TransactionsData,
    error,
    isLoading,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("allpayments"), {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  const {
    data: statsData,
    error: statsDataError,
    isLoading: statsDataLoadin,
    fetchData: fetchStatsData,
  } = useFetch(BASE_URL_TEST + urls("overallstats"), {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  const {
    data: allBNatureData,
    error: allBNatureError,
    isLoading: allBNatureLoading,
    fetchData: allBNatureFetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllBNature"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: dashboardMetricsData,
    error: dashboardMetricsError,
    isLoading: dashboardMetricsLoading,
    fetchData: fetchDashboardMetrics,
  } = useFetch(BASE_URL_TEST + urls("getDashboardMetrics"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  console.log("appStateToken", loginToken);

  const { formattedDate, formattedTime } = getDate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [paymentTransactions, setPaymentTransactions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const [statisticsData, setStatisticsData] = useState([]);
  const [dashboardMetrics, setDashboardMetrics] = useState({
    totalVendors: 0,
    activeVendors: 0,
    totalCustomers: 0,
    activeCustomers: 0,
    totalOrders: 0,
    totalSales: 0,
    recentOrders: [],
    last12Months: [],
  });
  const cards = [
    { title: "Total Orders", value: "$350.40", image: "/totalProducts.svg" },
    { title: "Completed Orders", value: "$642.39", image: "/orders.svg" },
    { title: "Cancelled Orders", value: "$642.39", image: "/orders.svg" },
    { title: "Today Revenue", value: "$2,000.00", image: "/Flag.svg " },
    { title: "Top Products", value: "154", image: "/topProducts.svg" },
  ];

  const images = [
    {
      image: "/totalProducts.svg",
    },
    {
      image: "/orders.svg",
    },
    {
      image: "/orders.svg",
    },
    {
      image: "/Flag.svg ",
    },
    {
      image: "/topProducts.svg",
    },
  ];
  const [captureSuccess, setCaptureSuccess] = useState(false);
  const [vendorChart, setVendorChart] = React.useState("this month");

  const handleStatusClick = (transaction) => {
    setSelectedTransaction(transaction);
    setCaptureSuccess(false);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCaptureClick = () => {
    setCaptureSuccess(true);
  };

  useEffect(() => {
    if (loginToken) {
      allBNatureFetchData();
      fetchDashboardMetrics();
    } else {
      // navigate('/sal')
    }
  }, []);

  useEffect(() => {
    if (dashboardMetricsData && dashboardMetricsData.status === true) {
      setDashboardMetrics(dashboardMetricsData.data);
    }
  }, [dashboardMetricsData, dashboardMetricsError]);

  useEffect(() => {
    console.log("TransactioDa", TransactionsData);
    if (
      TransactionsData &&
      TransactionsData["status"] === "success" &&
      TransactionsData["data"]["count"] > 0
    ) {
      setPaymentTransactions(TransactionsData["data"]["items"]);
    }
  }, [TransactionsData, error]);
  const cardsDataArray = [];

  useEffect(() => {
    if (statsDataError) {
    } else if (statsData) {
      console.log("statsData", statsData);
      if (statsData["status"] == "success") {
        // { title: 'Total Products', value: '$350.40', image: '/totalProducts.svg' },
        const statsDataarr = statsData["data"];
        const keysarray = Object.keys(statsData["data"]);
        // for (let index = 0; index < statsDataarr.length; index++) {
        //   // const element = array[index];
        //   cardsDataArray.push({ title: cards[index]['title'],value: statsData[index][keysarray[index]],image: ''+images[index]})

        // }
        console.log("cards length:", statsDataarr.length);
        for (let index = 0; index < cards.length; index++) {
          // Ensure statsData and keysarray are defined and have the necessary length
          if (
            index < statsDataarr.length &&
            index < keysarray.length &&
            index < images.length
          ) {
            // cardsDataArray.push({
            //     title: cards[index]['title'],
            //     value: statsData[index][keysarray[index]],
            //     image: images[index].image // Assuming images is an array of objects
            // });
          } else {
            console.warn(
              `Index ${index} is out of bounds for statsData, keysarray, or images`
            );
          }
        }

        setStatisticsData(statsData["data"]);
      }
    }
  }, [statsData, statsDataError]);

  const salesData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: [
      {
        label: "Revenue",
        data: [1200, 1900, 3000, 5000, 2300, 3400, 7000, 9000, 11000],
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 2,
        fill: false,
      },
    ],
  };

  const mostPurchasedProductsData = {
    labels: ["Light1", "Light2", "Light3", "Light4", "Light5", "Light6"],
    datasets: [
      {
        label: "Products",
        data: [100, 150, 200, 120, 130, 140],
        backgroundColor: [
          "rgba(75, 192, 192, 0.5)",
          "rgba(192, 75, 75, 0.5)",
          "rgba(75, 75, 192, 0.5)",
          "rgba(192, 192, 75, 0.5)",
          "rgba(75, 192, 75, 0.5)",
          "rgba(192, 75, 192, 0.5)",
        ],
      },
    ],
  };

  const d_cards = [
    {
      icon: <PersonIcon fontSize="medium" />,
      title: "Total Sales",
      value: `₹${dashboardMetrics.totalSales?.toLocaleString() || 0}`,
      percentage: "+25.5%",
      positive: true,
    },
    {
      icon: <ShoppingBagIcon fontSize="medium" />,
      title: "Total Orders",
      value: dashboardMetrics.totalOrders?.toLocaleString() || "0",
      percentage: "+4.10%",
      positive: true,
    },
    {
      icon: <AddIcon fontSize="medium" />,
      title: "Active Vendors",
      value: dashboardMetrics.activeVendors?.toLocaleString() || "0",
      percentage: "+5.1%",
      positive: true,
    },
    {
      icon: <RemoveIcon fontSize="medium" />,
      title: "Active Customers",
      value: dashboardMetrics.activeCustomers?.toLocaleString() || "0",
      percentage: "+25.5%",
      positive: true,
    },
  ];

  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    datasets: [
      {
        label: "Project Team",
        data: [40, 45, 50, 55, 53, 60, 65],
        borderColor: "green",
        backgroundColor: "rgba(0, 255, 0, 0.1)",
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
      {
        label: "Product Team",
        data: [35, 38, 40, 47, 50, 54, 58],
        borderColor: "orange",
        backgroundColor: "rgba(255, 165, 0, 0.1)",
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };  

  const vendor_pie_data = [
    { name: "Active Vendors", value: dashboardMetrics.activeVendors || 0 },
    { name: "Inactive Vendors", value: (dashboardMetrics.totalVendors - dashboardMetrics.activeVendors) || 0 },
  ];

  const customer_pie_data = [
    { name: "Active Customers", value: dashboardMetrics.activeCustomers || 0 },
    { name: "Inactive Customers", value: (dashboardMetrics.totalCustomers - dashboardMetrics.activeCustomers) || 0 },
  ];

  const pie_data = [
    { name: "Group A", value: 400 },
    { name: "Group B", value: 300 },
    { name: "Group C", value: 300 },
    { name: "Group D", value: 200 },
  ];

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill="#333"
        >{`PV ${value}`}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          dy={18}
          textAnchor={textAnchor}
          fill="#999"
        >
          {`(Rate ${(percent * 100).toFixed(2)}%)`}
        </text>
      </g>
    );
  };

  const VendorPerformance = () => {
    const data = [
      { name: "Jan", uv: 40, pv: 24 },
      { name: "Feb", uv: 30, pv: 13 },
      { name: "Mar", uv: 20, pv: 98 },
      { name: "Apr", uv: 27, pv: 39 },
      { name: "May", uv: 18, pv: 48 },
      { name: "Jun", uv: 23, pv: 38 },
      { name: "Jul", uv: 34, pv: 43 },
      { name: "Aug", uv: 45, pv: 54 },
    ];

    return (
      <div
        style={{
          width: "100%",
          height: "80%",
          backgroundColor: "#fff",
          borderRadius: "8px",
        }}
      >
        {/* <h3 style={{ marginBottom: "1rem" }}>Vendor's Performance</h3> */}
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={data}
            margin={
              {
                // top: 20,
                // right: 20,
                // left: 10,
                // bottom: 10,
              }
            }
            // style={{backgroundColor:'red'}}
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip contentStyle={{}} />
            <Legend verticalAlign="top" height={36} />
            <Line
              type="monotone"
              dataKey="pv"
              stroke="#ffc837"
              activeDot={{ r: 6 }}
            />
            <Line type="monotone" dataKey="uv" stroke="#0caf60" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const transactionData = (dashboardMetrics.recentOrders || []).map((order) => ({
    order_number: order.cart_number,
    transaction_id: order.transaction_id,
    amount: `₹${order.total_amount?.toLocaleString() || 0}`,
    status: order.order_status,
    time: order.time_ago,
  }));

  const [pieState, setPieState] = useState({
    activeIndex: 0,
  });

  const onPieEnter = (_, index) => {
    console.log("mouse enter", index);
    setPieState({ ...pieState, activeIndex: index });
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    setAnchorEl(null);
    navigate(path);
  };

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          // Hide scrollbar
          "&::-webkit-scrollbar": {
            display: "none", // For Chrome, Safari, and Edge
          },
          msOverflowStyle: "none", // For Internet Explorer and Edge
          scrollbarWidth: "none", // For Firefox
        }}
      >
        <AppHeaderBar
          title={"Welcome Admin"}
          onBackScreenName={handleScreeName}
        />

        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ padding: 1 }}>
            <Grid container spacing={1} sx={{ height: "50vh" }}>
              {/* Stats Box */}
              <Grid item xs={12} md={6} sx={{ height: "100%" }}>
                <Box
                  sx={{
                    padding: 2,
                    borderRadius: 2,
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    height: "100%",
                    borderRadius: "20px",
                  }}
                  mt={0}
                >
                  <Grid container spacing={2}>
                    {d_cards.map((card, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        key={index}
                        sx={{
                          borderRight:
                            index % 2 === 0 && index !== d_cards.length - 1
                              ? "1px solid #E0E0E0"
                              : "none",
                          borderBottom:
                            index < d_cards.length - 2
                              ? "1px solid #E0E0E0"
                              : "none",
                        }}
                      >
                        <Box
                          sx={{
                            padding: 2,
                            borderRadius: 0,
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
                            backgroundColor: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                        >
                          <IconButton
                            color="primary"
                            sx={{
                              backgroundColor: "#F4F6F8",
                              marginBottom: 1,
                            }}
                          >
                            {card.icon}
                          </IconButton>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography variant="h4" fontWeight="bold">
                              {card.value}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                backgroundColor: card.positive
                                  ? "#E8F5E9"
                                  : "#FFEBEE",
                                borderRadius: 10,
                                padding: "2px 6px",
                              }}
                            >
                              {card.positive ? (
                                <TrendingUpIcon
                                  fontSize="small"
                                  sx={{ color: "green" }}
                                />
                              ) : (
                                <TrendingDownIcon
                                  fontSize="small"
                                  sx={{ color: "red" }}
                                />
                              )}
                              <Typography
                                variant="body2"
                                sx={{
                                  color: card.positive ? "green" : "red",
                                  fontWeight: "bold",
                                  marginLeft: "4px",
                                }}
                              >
                                {card.percentage}
                              </Typography>
                            </Box>
                          </Box>
                          <Typography variant="body1" color="text.secondary">
                            {card.title}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Grid>

              {/* <Grid item xs={12} md={6} sx={{ height: "100%" }}>
                <Box
                  sx={{
                    padding: 2,
                    borderRadius: 2,
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    height: "100%",
                    borderRadius: "20px",
                  }}
                >
                  <Typography variant="h6" sx={{ marginBottom: 2 }}>
                    Vendor's Performance
                  </Typography>
                  <VendorPerformance />
                </Box>
              </Grid> */}

              {/* Total Vendors and Total Customers - moved from below */}
              <Grid item xs={12} md={6} sx={{ height: "100%" }}>
                <Box sx={{ display: "flex", flexDirection: "row", gap: 2, height: "100%", minHeight: "350px" }}>
                  <Card
                    sx={{
                      flex: 1,
                      padding: 2,
                      borderRadius: "20px",
                      minHeight: "300px",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold", marginBottom: 1 }}>
                      Total Vendor's ({dashboardMetrics.totalVendors || 0})
                    </Typography>
                    <ResponsiveContainer width="100%" height="85%">
                      <PieChart width={400} height={400}>
                        <Pie
                          activeIndex={0}
                          activeShape={renderActiveShape}
                          data={vendor_pie_data}
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={80}
                          fill="#8884d8"
                          dataKey="value"
                          onMouseEnter={onPieEnter}
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </Card>

                  <Card
                    sx={{
                      flex: 1,
                      padding: 2,
                      borderRadius: "20px",
                      minHeight: "300px",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold", marginBottom: 1 }}>
                      Total Customer's ({dashboardMetrics.totalCustomers || 0})
                    </Typography>

                    <ResponsiveContainer width="100%" height="85%">
                      <PieChart width={400} height={400}>
                        <Pie
                          activeIndex={0}
                          activeShape={renderActiveShape}
                          data={customer_pie_data}
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={80}
                          fill="#82ca9d"
                          dataKey="value"
                          onMouseEnter={onPieEnter}
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              height: "100vh",
              mt: 2,
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "100%",
                background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
                borderRadius: "20px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                margin: 2,
                padding: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 2,
                }}
              >
                <Typography
                  sx={{
                    width: "40%",
                    display: "flex",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  Recent Activity
                </Typography>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    placeholder="Search"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search sx={{ color: "#666" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "#f7f7f7",
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#ddd",
                        },
                        "&:hover fieldset": {
                          borderColor: "#aaa",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#666",
                        },
                      },
                    }}
                    variant="outlined"
                    size="small"
                  />
                </Box>
              </Box>

              <TableComponent
                title={""}
                headers={[
                  "Order Number",
                  "Transaction ID",
                  "Amount",
                  "Status",
                  "Time",
                ]}
                transactions={transactionData}
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "14px",
                    backgroundColor: "#f0f0f0",
                  },
                  "& tr:hover": {
                    backgroundColor: "#f9f9f9",
                  },
                  "& td": {
                    padding: "12px",
                  },
                }}
              />
            </Box>

            {/* Original Total Vendors and Total Customers section - moved above
            <Box sx={{ height: "100%", width: "30%" }} borderRadius={5} p={2}>
              <Card
                sx={{
                  height: "40%",
                  width: "100%",
                  padding: 2,
                  marginTop: 2,
                  borderRadius: "20px",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography sx={{ fontWeight: "bold", width: "60%" }}>
                    Total Vendor's
                  </Typography>

                  <Box
                    sx={{
                      width: "40%",
                      borderWidth: 1,
                      borderColor: "red",
                      height: "10%",
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        value={vendorChart}
                        style={{ borderWidth: 1, borderColor: "red" }}
                        onChange={() => {}}
                        displayEmpty
                        sx={{
                          border: "none",
                          outline: "none",
                          marginRight: 4,
                          textAlign: "right",
                          "& .MuiSelect-select": {
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-icon": {
                            right: "5px",
                          },
                          boxShadow: "none",
                          color: "#fff",
                        }}
                        disableUnderline
                      >
                        <MenuItem value="All Categories">this month</MenuItem>
                        <MenuItem value="All Categories">last week</MenuItem>
                        <MenuItem value="All Categories">last month</MenuItem>
                        <MenuItem value="All Categories">last year</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart width={400} height={400}>
                    <Pie
                      activeIndex={0}
                      activeShape={renderActiveShape}
                      data={pie_data}
                      cx="50%"
                      cy="50%"
                      innerRadius={60}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                      onMouseEnter={onPieEnter}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Card>

              <Card
                sx={{
                  height: "40%",
                  width: "100%",
                  padding: 2,
                  marginTop: 2,
                  borderRadius: "20px",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography sx={{ fontWeight: "bold", width: "60%" }}>
                    Total Customer's
                  </Typography>

                  <Box
                    sx={{
                      width: "40%",
                      borderWidth: 1,
                      borderColor: "red",
                      height: "10%",
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        value={vendorChart}
                        style={{ borderWidth: 1, borderColor: "red" }}
                        onChange={() => {}}
                        displayEmpty
                        sx={{
                          border: "none",
                          outline: "none",
                          marginRight: 4,
                          textAlign: "right",
                          "& .MuiSelect-select": {
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-icon": {
                            right: "5px",
                          },
                          boxShadow: "none",
                          color: "#fff",
                        }}
                        disableUnderline
                      >
                        <MenuItem value="All Categories">this month</MenuItem>
                        <MenuItem value="All Categories">last week</MenuItem>
                        <MenuItem value="All Categories">last month</MenuItem>
                        <MenuItem value="All Categories">last year</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>

                <ResponsiveContainer width="100%" height="100%">
                  <PieChart width={400} height={400}>
                    <Pie
                      activeIndex={0}
                      activeShape={renderActiveShape}
                      data={pie_data}
                      cx="50%"
                      cy="50%"
                      innerRadius={60}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                      onMouseEnter={onPieEnter}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Card>
            </Box>
            */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardContent;
